import axios from "axios";

// Test

// export const baseURL = "https://teststag.smrtstats.com:8888/api/v1";
// export const url = "https://teststag.smrtstats.com:8888";

// Prod

export const baseURL = "https://api-v0.smrtstats.com/api/v1";
export const url = "https://api-v0.smrtstats.com";
const langURL = 'https://lexicon.smrtstats.com/api'

export const instance = axios.create({
  baseURL,
});

export const $api_lang = axios.create({ baseURL: langURL });

const onlineURL = "https://api-v1.smrtstats.com/api";
export const $api_online = axios.create({ baseURL: onlineURL });